<!--
  Full view of the Provisionssatz (cp.ProvisionContractAgent). Exactly ONE shared component per
  active navItem — the shape of cp-provision-agent-full.component.html.
-->
@if (navigationItems && initialized) {

    <div class="cp-provision-contract-agent-full mt-4">

        @if (activeNavigationItem?.action == 'baseData') {
            <cp-provision-contract-agent-base-data
                    [provisionContractAgentId]="objectIdentifier.objectId">
            </cp-provision-contract-agent-base-data>
        }

        @if (activeNavigationItem?.action == 'amounts') {
            <cp-provision-contract-agent-amounts
                    [provisionContractAgentId]="objectIdentifier.objectId">
            </cp-provision-contract-agent-amounts>
        }

        <!-- navItem "Haftung": no pending fallback — all five liability fields are NOT NULL on
             the entity, so under FD-8 the wizard asks for them and they never stand empty. -->
        @if (activeNavigationItem?.action == 'liability') {
            <cp-provision-contract-agent-liability
                    [provisionContractAgentId]="objectIdentifier.objectId">
            </cp-provision-contract-agent-liability>
        }

        <!-- navItem "Vertrag": the contract and the Provisionszeile behind the Satz. The
             Provisionszeile block carries the six deferred parent fields, likewise with the
             pending hint per field. -->
        @if (activeNavigationItem?.action == 'contract') {
            <cp-provision-contract-agent-contract
                    [provisionContractAgentId]="objectIdentifier.objectId">
            </cp-provision-contract-agent-contract>
        }

        @if (activeNavigationItem?.action == 'transactions') {
            <cp-provision-contract-agent-transactions
                    [provisionContractAgentId]="objectIdentifier.objectId">
            </cp-provision-contract-agent-transactions>
        }

        @if (activeNavigationItem?.action == 'cancellation') {
            <cp-provision-contract-agent-cancellation
                    [provisionContractAgentId]="objectIdentifier.objectId">
            </cp-provision-contract-agent-cancellation>
        }

    </div>

}
